import LOGO from "../../../assets/images/logoForInvoice.jpeg";
import QRCode from "../../../assets/images/qurcode.jpeg";
import { currencyFormat } from "../../../helpers";
import { dateFormat } from "../../../helpers/date-helpers";
import IRANSansRegular from "../../../assets/fonts/woff2/IRANSansWeb(FaNum).woff2";
import IRANSansBold from "../../../assets/fonts/woff2/IRANSansWeb(FaNum)_Bold.woff2";
import moment from "moment-jalaali";

const escapeHtml = (value) =>
    String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");


const dateOnlyFormat = (date) => date ? moment.utc(date).locale("fa").format("jYYYY/jMM/jDD") : "";
const invoiceMoney = (value) => currencyFormat(Number(value || 0));

const invoiceItemTotal = (item) =>
    (
        Number(item.price || 0) -
        Number(item.discount || 0) +
        (item.lens
            ? Number(item.lens.price || 0) -
            Number(item.lens.insuranceContribution || 0)
            : 0)
    ) * Number(item.count || 0);

const fallbackShopInfo = {
    address: "تهران، خیابان فلسطین، نبش بن‌بست فازی پلاک ۳۳۱",
    telephone: "۰۲۱-۶۶۴۴۳۳۳۰",
    website: "www.inakshop.com",
};

export default function printInvoice({ order, fallbackOrder, initials }) {
    const inPersonOrder = order.orderType === "inPerson";
    
    const source = order || fallbackOrder || {};
    const items = source?.items || [];
    const customer = source?.user || fallbackOrder?.user || {};
    const trackingCode = source?.trackingCode || fallbackOrder?.trackingCode || "";
    const createDate = source?.createDate || fallbackOrder?.createDate;
    const shopAddress = initials?.address || fallbackShopInfo.address;
    const shopTelephone =
        initials?.shopTelephone || initials?.telephone || fallbackShopInfo.telephone;
    const shopPostalCode = initials?.postalCode || "";
    const shopSocialMediaNumbers = initials?.socialMediaNumbers || "";
    const shopWebsite = 'inakshop.com';
    const shopInfoLines = [
        shopPostalCode ? `<div>کد پستی: ${escapeHtml(shopPostalCode)}</div>` : "",
        shopTelephone ? `<div>تلفن: ${escapeHtml(shopTelephone)}</div>` : "",
        shopSocialMediaNumbers
            ? `<div>شبکه‌های اجتماعی: ${escapeHtml(shopSocialMediaNumbers)}</div>`
            : "",
    ].join("");
    const invoiceRows = items
        .map((item, index) => {
            const itemName = [item.category, item.brand, item.name, item.color]
                .filter(Boolean)
                .join(" ");
            return `
                <tr>
                    <td>${index + 1}</td>
                    <td>${escapeHtml(itemName)}</td>
                    <td>${escapeHtml(item.count || "")}</td>
                    <td>${escapeHtml(invoiceMoney(item.price))}</td>
                </tr>
                ${
                    item.lens
                        ? `<tr>
                            <td></td>
                            <td>${escapeHtml(`عدسی ${item.lens.name || ""}`)}</td>
                            <td></td>
                            <td>${escapeHtml(invoiceMoney(item.lens.price))}</td>
                            
                        </tr>`
                        : ""
                }
            `;
        })
        .join("");
    const renderedRowCount = items.reduce(
        (sum, item) => sum + 1 + (item.lens ? 1 : 0),
        0
    );
    const emptyRows = Array.from({ length: Math.max(0, 3 - renderedRowCount) })
        .map(() => "<tr><td>&nbsp;</td><td></td><td></td><td></td></tr>")
        .join("");
    const doctorNames = Array.from(
        new Set(
            items
                .map(
                    (item) =>
                        item.userGlassLens?.coordination?.prescription?.doctorName
                )
                .filter(Boolean)
        )
    );
    const doctorFieldHtml = doctorNames.length
        ? `<div class="line-field"><span>نام دکتر:</span><span>${escapeHtml(
            doctorNames.join("، ")
        )}</span></div>`
        : "";
    const invoiceScale = Math.max(
        0.72,
        Math.min(1, 1 - Math.max(0, renderedRowCount - 8) * 0.035)
    );
    const paidAmount = Number(source?.depositAmount || 0);
    const printWindow = window.open("", "_blank", "width=900,height=1200");
    if (!printWindow) return;

    let thanksText = `<div class="thanks">با تشکر از خرید شما</div>`;
    if(inPersonOrder){
        thanksText += `<div class="thanks">چون حق انتخاب با شماست عینک فروخته شده تعویض یا پس گرفته نمیشود </div>`
    }

    printWindow.document.write(`
        <!doctype html>
        <html lang="fa" dir="rtl">
        <head>
            <meta charset="utf-8" />
            <title>فاکتور ${escapeHtml(trackingCode)}</title>
            <style>
                @font-face {
                    font-family: "IRANSans";
                    src: url("${IRANSansRegular}") format("woff2");
                    font-weight: 400;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "IRANSans";
                    src: url("${IRANSansBold}") format("woff2");
                    font-weight: 700;
                    font-style: normal;
                    font-display: swap;
                }
                @page { size: A4; margin: 7mm; }
                * { box-sizing: border-box; }
                body {
                    margin: 0;
                    background: #fff;
                    color: #111;
                    font-family: "IRANSans", sans-serif;
                    font-size: 11pt;
                    direction: rtl;
                    zoom: ${invoiceScale};
                }
                .invoice {
                    width: 196mm;
                    height: 282mm;
                    margin: 0 auto;
                    padding: 2mm 0;
                    overflow: hidden;
                }
                .header {
                    display: grid;
                    grid-template-columns: 1fr 72mm 1fr;
                    align-items: center;
                    border-bottom: 1px solid #111;
                    padding-bottom: 5px;
                }
                .logo { width: 40mm; justify-self: end; }
                .qrCodeLOGO { width: 52px; }
                .title-box {
                    border: 1px solid #999;
                    height: 14mm;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                }
                .customer {
                    margin-top: 7mm;
                    width: 92mm;
                }
                .line-field {
                    display: grid;
                    grid-template-columns: 28mm 1fr;
                    gap: 4mm;
                    border-bottom: 1px solid #999;
                    min-height: 5.5mm;
                    align-items: end;
                    font-weight: 700;
                    margin-top: 3mm;
                }
                .middle {
                    margin-top: 5mm;
                    display: grid;
                    grid-template-columns: 92mm 1fr;
                    gap: 18mm;
                    align-items: center;
                }
                .notice {
                    border: 1px solid #999;
                    min-height: 27mm;
                    padding: 6mm 7mm;
                    text-align: justify;
                    line-height: 1.75;
                    font-size: 10.5pt;
                }
                .contact {
                    line-height: 1.65;
                    font-weight: 700;
                }
                .contact-grid {
                    display: grid;
                    grid-template-columns: 16mm 1fr;
                    gap: 3mm;
                    align-items: center;
                    margin-top: 2mm;
                    font-weight: 400;
                }
                .qr {
                    width: 15mm;
                    height: 15mm;
                    border: 2px solid #111;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    direction: ltr;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 9mm;
                    direction: rtl;
                }
                th {
                    border: 0;
                    padding: 0 1.5mm 2mm;
                    font-weight: 700;
                }
                td {
                    border: 1px solid #aaa;
                    height: 6mm;
                    padding: 0.7mm 1.5mm;
                    vertical-align: middle;
                }
                th:nth-child(1), td:nth-child(1) { width: 14mm; text-align: center; }
                th:nth-child(2), td:nth-child(2) { width: 84mm; }
                th:nth-child(3), td:nth-child(3) { width: 14mm; text-align: center; }
                th:nth-child(4), td:nth-child(4) { width: 38mm; text-align: center; }
                th:nth-child(5), td:nth-child(5) { width: 38mm; text-align: center; }
                .summary {
                    width: 92mm;
                    margin-top: 4mm;
                    margin-right: auto;
                    display: flex;
                    flex-direction: column;
                }
                .summary-row:first-child { order: 1; }
                .summary-row {
                    display: grid;
                    grid-template-columns: 34mm 1fr;
                    border-bottom: 1px solid #aaa;
                    min-height: 6.5mm;
                    align-items: center;
                }
                .summary-row strong { font-weight: 800; }
                .footer {
                    margin-top: 9mm;
                    display: grid;
                    grid-template-columns: 1fr 92mm;
                    gap: 14mm;
                }
                .signature {
                    border-bottom: 1px solid #111;
                    min-height: 10mm;
                    padding-top: 1mm;
                    font-weight: 700;
                }
                .thanks {
                    margin-top: 4mm;
                    text-align: center;
                    font-weight: 700;
                }
                @media print {
                    html, body {
                        width: 196mm;
                        height: 283mm;
                        overflow: hidden;
                        print-color-adjust: exact;
                        -webkit-print-color-adjust: exact;
                    }
                    .invoice { page-break-after: avoid; page-break-inside: avoid; }
                }
            </style>
        </head>
        <body>
            <main class="invoice">
                <section class="header">
                <div class="title-box">فاکتور خرید</div>
                <div></div>
                <img class="logo" src="${LOGO}" alt="INAK Shop" />
                </section>

                <section class="customer">
                    <div class="line-field"><span>نام و نام خانوادگی:</span><span>${escapeHtml(customer.fullName)}</span></div>
                    <div class="line-field"><span>تاریخ خرید:</span><span>${escapeHtml(dateOnlyFormat(createDate))}</span></div>
                    <div class="line-field"><span>شماره خرید:</span><span>${escapeHtml(trackingCode)}</span></div>
                    ${doctorFieldHtml}
                </section>

                <section class="middle">
                </section>

                <table>
                    <thead>
                        <tr>
                            <th>شماره</th>
                            <th>نوع کالا</th>
                            <th>تعداد</th>
                            <th>قیمت</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${invoiceRows}
                        ${emptyRows}
                    </tbody>
                </table>

                <div style="display: flex; margin-top: 15px;">
                    <div class="contact">
                        ارتباط با ما
                        <div>${escapeHtml(shopAddress)}</div>
                        <div class="contact-grid">
                            <div class="qr">
                                <img class="qrCodeLOGO" src="${QRCode}" alt="QRCode" />
                            </div>
                            <div>
                                ${shopInfoLines}
                            </div>
                        </div>
                        <div style="direction:ltr;text-align:left;font-weight:400;">${escapeHtml(shopWebsite)}</div>
                    </div>
                <section class="summary">
                    <div class="summary-row"><strong>مجموع خرید:</strong><span style="justify-content: end; display: flex;">${escapeHtml(invoiceMoney(source?.totalAmount))}</span></div>
                    <div class="summary-row"><strong>تخفیف:</strong><span style="justify-content: end; display: flex;">${escapeHtml(invoiceMoney(source?.totalDiscount))}</span></div>
                    <div class="summary-row"><strong>مالیات:</strong><span style="justify-content: end; display: flex;">${escapeHtml(invoiceMoney(0))}</span></div>
                    <div class="summary-row"><strong>مجموع قابل پرداخت:</strong><span style="justify-content: end; display: flex;">${escapeHtml(invoiceMoney(source?.payableAmount))}</span></div>
                    <div class="summary-row"><strong>پرداخت شده:</strong><span style="justify-content: end; display: flex;">${escapeHtml(invoiceMoney(paidAmount))}</span></div>
                </section>

                </div>

                <section class="footer">
                    <div style="display: flex; align-items: end; margin-bottom: -30px;"><strong>مهر و امضا:</strong></div>
                    <div>
                        <div class="signature"></div>
                        ${thanksText}
                    </div>
                </section>
            </main>
            <script>
                window.onload = function() {
                    window.focus();
                    window.print();
                };
            </script>
        </body>
        </html>
    `);
    printWindow.document.close();
}
